module.exports = __webpack_public_path__ + "static/media/actiona.9867d738.svg";